export const meta = {
  id: "FW-32",
  name: "Wolfhour",
  slug: "wolfhour",
  title: "Wolfhour — a Fable World: agency waitlist page",
  description:
    "An original agency waitlist designed by Fable: particle type that startles like moths, an indigo 3am collage, a list for Q1."
} as const;

export type WorldMeta = typeof meta;

/**
 * The registry globs `world.meta.ts` and reads the NAMED export `meta` — that is the
 * contract, and `meta.slug` must equal this directory's name or the registry says so
 * out loud. The default export is kept only because two Wave-1 worlds shipped that way.
 */
export default meta;
